import hyperid from 'hyperid';
import { createSelector } from 'reselect';
import {
  MARK_AS_SHOWN,
  PERSONAL_EVENTS,
  SET_PERSONAL_INFO,
  USER_IS_READY_FOR_NEW_PERSONAL_DATA,
} from '../../../../constants/centrifugo';
import { PROJECTS } from '../../../../../constants/centrifugo';

const initialState = {
  data: [],
  isReady: false,
};

export const personalChannelReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERSONAL_INFO: {
      const data = action?.payload || {};
      return {
        ...state,
        data: [
          ...state?.data,
          {
            id: hyperid().uuid,
            ...(typeof data === 'object' && data !== null ? data : {}),
            isShown: false,
          },
        ],
        isReady: false,
      };
    }

    case MARK_AS_SHOWN: {
      return state.data?.map((event) => {
        if (event.id === action?.payload) {
          return {
            ...event,
            wasShown: true,
          };
        }
        return event;
      });
    }

    case USER_IS_READY_FOR_NEW_PERSONAL_DATA:
      return {
        ...state,
        isReady: action?.payload,
      };
    default: {
      return state;
    }
  }
};

const eventsSelector = (state) =>
  state?.domain?.centrifugo?.[PROJECTS.PERSONAL]?.data || initialState?.data;

export const isUserReadyToGetNewEvent = (state) =>
  state?.domain?.centrifugo?.[PROJECTS.PERSONAL]?.isReady ||
  initialState?.isReady;

const insufficientEventsSelector = createSelector(eventsSelector, (state) =>
  state?.filter((item) => item?.type === PERSONAL_EVENTS.INSUFFICIENT_BALANCE)
);

export const notShownInsufficientEventSelector = createSelector(
  insufficientEventsSelector,
  (state) => state?.find((item) => !item?.wasShown)
);
